export interface AddressDetailsI {
  country: string;
  state: string;
  city: string;
  zipCode: string;
  address1: string;
  address2: string;
}
